export enum PaymentSourceEnum {
  CARD = 'CARD',
  BANK_ACCOUNT = 'BANK_ACCOUNT',
  QR = 'QR',
  TRANSFER = 'TRANSFER',
  USSD = 'USSD',
  BROKER = 'BROKER'
}

